import { useState, useCallback } from 'react';
import { LoanOffer } from '../types';
import * as d3 from 'd3';

export interface UserOfferState {
  loanAmount: number;
  interestRate: number;
  duration?: number;
  collection?: string;
  collectionAddress?: string;
}

export const useUserOffer = () => {
  const [userOffer, setUserOffer] = useState<UserOfferState>({
    loanAmount: 1.0,
    interestRate: 5.0,
    duration: undefined,
  });

  const updateUserOffer = useCallback((updates: Partial<UserOfferState>) => {
    setUserOffer(prev => ({
      ...prev,
      ...updates,
    }));
  }, []);

  const resetUserOffer = useCallback(() => {
    setUserOffer({
      loanAmount: 1.0,
      interestRate: 5.0,
      duration: undefined,
    });
  }, []);

  const initializeWithMedianValues = useCallback((marketOffers: LoanOffer[]) => {
    if (marketOffers.length === 0) return;

    // Filter out any offers that might be the user's offer (those without an id)
    const validMarketOffers = marketOffers.filter(offer => offer.id);
    if (validMarketOffers.length === 0) return;

    // Use d3.median for both medians
    const medianAmount = d3.median(validMarketOffers, o => o.loanAmount) || 0;
    const medianRate = d3.median(validMarketOffers, o => o.interestRate) || 0;

    setUserOffer(prev => ({
      ...prev,
      loanAmount: medianAmount,
      interestRate: medianRate,
      // duration is not set or modified here
    }));
  }, []);

  return {
    userOffer,
    updateUserOffer,
    resetUserOffer,
    initializeWithMedianValues,
  };
}; 